import { commonRequestData, fetchData } from "../../api";

export const traerTodosLosCalendarios = async () => {
    // Prepara los datos comunes necesarios para la solicitud, combinando commonRequestData con otros datos necesarios.
    const requestData = {
        ...commonRequestData, // Incluye los parámetros comunes de la solicitud en requestData.
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la lista de calendarios.
    // El primer parámetro "calendarios/lista" indica el endpoint o recurso al que se hará la petición.
    const response = await fetchData("calendarios/lista", requestData);

    // Retorna la respuesta obtenida de la API, que contiene los calendarios.
    return response;
};

export const traerTodosLoSalones = async ({ SalonesId }) => {
    // Prepara los datos comunes necesarios para la solicitud, combinando commonRequestData con el ID de los salones.
    const requestData = {
        ...commonRequestData, // Incluye los parámetros comunes de la solicitud en requestData.
        SalonesId, // Agrega el ID de los salones para filtrar los resultados.
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la lista de salones.
    // El primer parámetro "calendarios/salones" indica el endpoint o recurso al que se hará la petición.
    const response = await fetchData("calendarios/salones", requestData);

    // Retorna la respuesta obtenida de la API, que contiene la lista de salones.
    return response;
};

export const traerTodosEventos = async ({ SalonesId, startValue, endValue }) => {
    // Prepara los datos comunes necesarios para la solicitud, combinando commonRequestData con el ID de los salones.
    const requestData = {
        ...commonRequestData, // Incluye los parámetros comunes de la solicitud en requestData.
        SalonesId, // Agrega el ID de los salones para filtrar los resultados de eventos.
        startValue,
        endValue,
    };

    // Realiza una solicitud a la API utilizando fetchData para obtener la lista de eventos asociados a los salones.
    // El primer parámetro "calendarios/eventos" indica el endpoint o recurso al que se hará la petición.
    const response = await fetchData("calendarios/eventos", requestData);

    // Retorna la respuesta obtenida de la API, que contiene los eventos.
    return response;
};

/**
 * Mueve un evento a una nueva fecha/hora en el sistema.
 *
 * @param {Object} params - Objeto que contiene los parámetros necesarios para la solicitud.
 * @param {number} params.id - ID del evento a mover.
 * @param {string} params.eventStart - Nueva fecha y hora de inicio del evento (formato 'YYYY-MM-DD HH:mm:ss').
 * @param {string} params.eventEnd - Nueva fecha y hora de finalización del evento (formato 'YYYY-MM-DD HH:mm:ss').
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API.
 */
export const MoverEvento = async ({ id, eventStart, eventEnd, id_salon }) => {
    // Combina los datos comunes necesarios con los parámetros específicos para la solicitud.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, token de autenticación).
        id, // ID del evento que se desea mover.
        eventStart, // Nueva hora de inicio del evento.
        eventEnd, // Nueva hora de finalización del evento.
        id_salon,
    };

    try {
        // Realiza la solicitud a la API para mover el evento.
        // Usa el endpoint "calendarios/MoverEvento" para procesar la solicitud.
        const response = await fetchData("calendarios/MoverEvento", requestData);

        // Retorna la respuesta obtenida de la API.
        return response;
    } catch (error) {
        // Maneja y registra cualquier error que ocurra durante la solicitud.
        console.error("Error al mover el evento:", error.message);

        // Opcional: puedes lanzar el error para que sea manejado por el código que llama a esta función.
        throw new Error("No se pudo mover el evento.");
    }
};



/**
 * Obtiene un evento específico desde el backend utilizando su ID.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {number} params.id - ID único del evento a obtener.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, que incluye los datos del evento.
 * @throws {Error} Lanza un error si la solicitud falla.
 */
export const obtener_EventoEspesifico = async ({ id }) => {
    // Combina los datos comunes necesarios con los parámetros específicos para la solicitud.
    const requestData = {
        ...commonRequestData, // Incluye datos comunes como headers y token de autenticación.
        id, // ID del evento a buscar.
    };

    try {
        // Realiza la solicitud a la API para obtener los datos del evento.
        // Usa el endpoint "calendarios/obtener_EventoEspesifico" para procesar la solicitud.
        const response = await fetchData("calendarios/obtener_EventoEspesifico", requestData);

        // Retorna la respuesta obtenida de la API.
        return response;
    } catch (error) {
        // Maneja y registra cualquier error que ocurra durante la solicitud.
        console.error("Error al obtener el evento específico:", error.message);

        // Lanza un error con un mensaje amigable para ser manejado por el controlador de la función.
        throw new Error("No se pudo obtener los datos del evento específico.");
    }
};

export const extaereporteApi = async ({ startValue, endValue }) => {
    // Combina los datos comunes necesarios con los parámetros específicos para la solicitud.
    const requestData = {
        ...commonRequestData, // Incluye datos comunes como encabezados y token de autenticación.
        startValue,
        endValue,
    };

    try {
        // Realiza una solicitud a la API para obtener los datos del reporte.
        // Utiliza el endpoint "calendarios/obtener_reporteEvento" para procesar la solicitud.
        const response = await fetchData("calendarios/obtener_reporteEvento", requestData);

        // Devuelve la respuesta obtenida de la API.
        return response;
    } catch (error) {
        // Maneja y registra cualquier error que ocurra durante la solicitud.
        console.error("Error al obtener el reporte del evento:", error.message);

        // Lanza un error con un mensaje amigable para ser manejado externamente.
        throw new Error("No se pudo obtener los datos del reporte del evento.");
    }
};
